import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_2xl,
  font_size_lg,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.SaasActionRequiredModal .BaseModal-Body {
    display: flex;
    flex-direction: column;
    gap: ${spacing(10)};
    padding: ${spacing(10)};
    border-radius: 10px;

    .SaasActionRequiredModal-Text {
      display: flex;
      flex-direction: column;
      gap: ${spacing(5)};

      header {
        font-family: ${font_family_weight_medium};
        font-size: ${font_size_2xl};
        /* TODO: use ext-ui/style instead of hardcoding */
        line-height: 24px;
        color: ${text_colorTextPrimary};
      }
      p {
        font-family: ${font_family_weight_regular};
        font-size: ${font_size_lg};
        /* TODO: use ext-ui/style instead of hardcoding */
        line-height: 20px;
        color: ${text_colorTextPrimary};
      }
    }

    .SaasActionRequiredModal-CTA {
      display: flex;
      flex-direction: row;
      gap: ${spacing(6)};

      .SaasActionRequiredModal-CTA-Button {
        padding: ${spacing(4)} ${spacing(8)};
      }
    }

    .SaasActionRequiredModal-Footer {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: ${spacing(1)};
      align-self: stretch;

      img {
        padding: 3px 0px;
      }
      span {
        font-family: ${font_family_weight_regular};
        font-size: ${font_size_lg};
        /* TODO: use ext-ui/style instead of hardcoding */
        line-height: 20px;
        color: ${text_colorTextSecondary};
      }
    }
  }
`
